<template>
  <el-dialog
    title="安全验证"
    :visible.sync="dVisible"
    width="700px"
    top="10vh"
    :append-to-body="true"
    :destroy-on-close="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @closed="handleDialogClosed"
    @close="hide"
  >
    <div class="captcha-dialog-content">
      <div class="iframe-wrapper">
        <iframe
          :src="captchaUrl"
          ref="iframeRef"
        ></iframe>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    captchaUrl: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      dVisible: true,
    }
  },
  mounted() {
    window.addEventListener('message', this.handleMessage);
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage);
  },
  methods: {
    handleMessage(event) {
      try {
        const data = event.data;
        console.log(data, '-----data')
        if (data && data.type === 'captcha-verified') {
          this.dVisible = false;
          this.$emit('verified');
        }
      } catch (error) {
        console.error('处理 iframe 消息出错:', error);
      }
    },

    handleDialogClosed() {
      window.removeEventListener('message', this.handleMessage);
    },

    hide() {
      this.dVisible = false;
      this.$emit('cancel');
    }
  }
}
</script>

<style scoped lang="less">
.captcha-dialog-content {
  height: 450px;
  overflow: hidden;

  .iframe-wrapper {
    width: 100%;
    height: 100%;

    iframe {
      width: 100%;
      height: 100%;
      border: none;
    }
  }
}

/deep/ .el-dialog__header {
  padding: 8px 10px;
  background: #f7f7f7;

  .el-dialog__title {
    font-size: 14px;
  }

  .el-dialog__headerbtn {
    top: 12px;
    right: 10px;
    line-height: 16px;
  }
}

/deep/ .el-dialog__body {
  padding: 0px 10px 10px 10px;
}
</style>
